export const ACCOUNT_SELECT = `
  id, name, uid, type, balance, customer_balance, vendor_balance,
  is_customer, is_vendor, photo, created_at
`;

export const PRODUCT_SELECT = `
  id, product_name, vendor_product_name, sku, uid,
  quantity, cost, total_cost, category, kanban_status, photo_url,
  is_sample, is_fronted, is_miscellaneous, is_service, total_units_behind_sample,
  is_deleted, purchase_order_id, purchase_order_uid, account_id, created_at, notes
`;
